export enum ViewMode {
  LIST = 'listView',
  GRID = 'gridView',
  // MAP = 'mapView',
}
